import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findengineerOrder = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_order_mini?` + params,
        method: 'GET'
    })
}
export const deliverGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-dsrms/v1/resource/engineer_order_mini/send`,
        method: 'PUT',
        data: data
    })
}
export const findEngineerSendData=(id)=>{
    return request({
        url: `${baseUrl}/joins-product/v1/order/findEngineerSendData/${id}`,
        method: 'GET'
    })
}
export const send=(data)=>{
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_order_mini/send`,
        method: 'PUT',
        data: data
    })
}